import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';

export interface AuthorizedDeviceRemoveDialogProps {
    active: boolean;
    onUserRemove: () => void;
    onClose: () => void;
}

export function AuthorizedDeviceRemoveDialog({ active, onClose, onUserRemove }: AuthorizedDeviceRemoveDialogProps) {
    return (
        <Dialog
            active={active}
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.AuthorizedDeviceRemoveDialogTitle} />}
            footer={{
                secondary: (
                    <Button onClick={onClose} variant="tertiary" size="medium" type="button">
                        <LocalizedText textKey={TextKey.GoBack} />
                    </Button>
                ),
                primary: (
                    <Button
                        onClick={() => {
                            onUserRemove();
                            onClose();
                        }}
                        variant="primary"
                        size="medium"
                        type="button"
                        data-test-id="remove-device-button"
                    >
                        <LocalizedText textKey={TextKey.Remove} />
                    </Button>
                ),
            }}
        >
            <LocalizedText textKey={TextKey.AuthorizedDeviceRemoveDialogContent} />
        </Dialog>
    );
}
